import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledNoDataWrapper = styled.div<{ height?: string }>`
    position: relative;
    display: flex;
    align-items: flex-end;
    height: ${({ height = "115px" }) => height};
    background: ${colorsPalettes.sky[100]};
    border: 1px solid rgba(202, 202, 202, 0.14);
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
`;

export const StyledNoDataImage = styled.img`
    max-height: 110px;
`;

export const StyledNoDataContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    width: 100%;
    max-width: 643px;
    margin-left: 27px;
`;

export const StyledNoDataSubtitle = styled.span<{ withChildren: boolean }>`
    margin-top: ${({ withChildren }) => (withChildren ? "8px" : "0")};
    ${mixins.setFontVariant("h6", colorsPalettes.carbon["400"])};
    font-weight: 400;
`;
